// Reducers

const initialState = {
    members: [],
    currentUser: {}, // { id: "...", token: "..." }
    profile: {}, // { id, email,... }
    schedule: [],
    memberNameMap: {},
    memberIdMap: {},
    hub: {},
    unreadMessages: {},
    chatWindow: null, // the chat pop-up's window handle, set from NewWindow's onOpen
    shouldAllowWindowAutoClose: true,
    shouldTurnFlashOn: false,
    //shouldDisplayChat: false,
    preferences: {},
};

function constructUnreadMessages(state, userId, isRead) {
    // The nested object needs its own identity. This used to spread one level
    // deep and then assign into the original unreadMessages, so the object was
    // mutated in place and stayed reference-equal - connect compares mapped
    // props shallowly, saw no change, and skipped the re-render. The chat tabs
    // hid that behind the 1s flash tick that repaints them anyway;
    // MemberListItem has no such timer and was left showing a stale marker.
    var unreadMessages = { ...state['unreadMessages'] };
    unreadMessages[userId] = isRead;
    return { ...state, unreadMessages: unreadMessages };
}

// Rows come back as [{category, name, value}]; the app reads them as a flat
// "category.name" map. Built fresh each time so the slice gets a new identity.
function constructPreferences(rows) {
    const map = {};
    (rows || []).forEach(row => {
        if (row && row.category && row.name) {
            map[row.category + '.' + row.name] = row.value;
        }
    });
    return map;
}

function constructMemberMaps(members) {
    var memberMapIdToMember = {};
    var memberMapNameToMember = {};
    for (var i = 0; i < members.length; i++) {
        var member = members[i];
        var memberName = member.firstName + " " + member.lastName;
        memberMapNameToMember[memberName] = member;
        memberMapIdToMember[member['id']] = member;
    }
    return [memberMapNameToMember, memberMapIdToMember];
}

// The toggled schedule and its checkedUserIds get new identities; the others
// are passed through untouched. This used to assign into - and push onto - the
// schedule objects already in the store, so the previous state was rewritten
// in place and anything holding the old schedule (connect's shallow compare,
// OnCallScheduleList's copy in its own state) saw the change without being
// told, or was not told at all.
function toggleUserState(state, action) {
    var userId = action['payload']['userId'];
    return state.schedule.map(currentSchedule => {
        if (currentSchedule['company'] !== action['payload']['company']) {
            return currentSchedule;
        }
        var checked = currentSchedule['checkedUserIds'] || [];
        var newChecked = checked.indexOf(userId) !== -1
            ? checked.filter(val => val !== userId)
            : checked.concat([userId]);
        return { ...currentSchedule, checkedUserIds: newChecked };
    });
}

function reducers(state = initialState, action) {
    switch (action.type) {
        case 'LOGIN_USER': // this is loaded right after logging in
            return { ...state, 'currentUser': action.payload }
        case 'DATA_LOADED': // this is loaded before logging in
            var memberMaps = constructMemberMaps(action.payload);
            return { ...state, members: action.payload.slice(0), memberNameMap: memberMaps[0], memberIdMap: memberMaps[1] }
        case 'LOAD_SCHEDULE':
            return { ...state, schedule: action.payload };
        case 'TOGGLE_EMAIL_LIST_USER':
            return { ...state, schedule: toggleUserState(state, action) };
        case 'LOGOUT_USER':
            return { ...state, currentUser: {} };
        case 'PROFILE_LOAD':
            return { ...state, profile: action.payload };
        case 'INITIATE_CONNECTION':
            return { ...state, hub: action.payload['connection'] }
        case 'UNREAD_MESSAGE':
            return constructUnreadMessages(state, action.payload['post']['payload']['userId'], true);
        case 'READ_MESSAGE':
            return constructUnreadMessages(state, action.payload.userId, false);
        case 'UNREAD_MESSAGE_FETCH':
            var tempState = { ...state };
            for (var i = 0; i < action.payload.length; i++) {
                tempState = constructUnreadMessages(tempState, action.payload[i], true);
            }
            // An empty answer leaves unreadMessages at {}, same as "not fetched
            // yet"; MemberList's startup chat window needs to tell them apart.
            return { ...tempState, unreadLoaded: true };
        case 'UNREAD_MESSAGE_USER_FETCH':
            //tbd
            // Was `return tempState` - a var belonging to the case above, so on
            // this dispatch it was undefined and took the whole store with it.
            // Harmless only because nothing dispatches this action yet.
            return state;
        case 'TAB_INDEX':
            return { ...state, currentTabIndex: action.payload['tabIndex'] }
        case 'SET_CHAT_WINDOW':
            return { ...state, chatWindow: action.payload['chatWindow'] }
        case 'SET_BULLETIN':
            return { ...state, 'shouldDisplayBulletin': action.payload['shouldDisplay'] }
        case 'SET_USER_MANAGER':
            return { ...state, 'shouldDisplayUserManager': action.payload['shouldDisplay'] }
        case 'SET_CHAT_DISPLAY':
            return { ...state, 'shouldDisplayChat': action.payload['shouldDisplay'] }
        case 'SET_ICON_FLASH':
            return { ...state, 'shouldTurnFlashOn': action.payload['shouldTurnFlashOn'] }
        case 'ALLOW_WINDOW_AUTO_CLOSE':
            //console.log(action.payload);
            return { ...state, 'shouldAllowWindowAutoClose': action.payload['windowAutoClose'] }
        case 'SET_DISCONNECTED':
            // A copy, not the profile in the store. Assigning into
            // state.profile kept its identity, so connect saw no change and
            // skipped the re-render, and the previous state was rewritten
            // under anything still holding it.
            return { ...state, 'profile': { ...state.profile, status: 'Disconnected', inOffice: false } }
        case 'SET_GROUP_MANAGER':
            return { ...state, 'shouldDisplayGroupManager': action.payload['shouldDisplay'] }
        case 'PREFERENCES_LOAD':
            // preferencesLoaded tells "stored nothing" apart from "not fetched
            // yet" - both are an empty map - for anything that must not act on
            // a default the user may have turned off (the login bulletin).
            return { ...state, preferences: constructPreferences(action.payload), preferencesLoaded: true };
        default:
            return state;
    }
}

export default reducers;


// WEBPACK FOOTER //
// ./src/reducers/reducers.js


// WEBPACK FOOTER //
// ./src/reducers/reducers.js